// import { marks } from 'prosemirror-schema-basic';

// Extend the schema with citation mark
export const citationMark = {
  attrs: {
    citationId: { default: null },
    citationText: { default: '' },
  },
  inclusive: false,
  parseDOM: [
    {
      tag: 'span.citation-mark',
      getAttrs(dom) {
        return {
          citationId: dom.getAttribute('data-citation-id'),
          citationText: dom.getAttribute('data-citation-text'),
        };
      },
    },
    {
      tag: 'cite', // Fallback for old content
      getAttrs(dom) {
        return {
          citationId: dom.getAttribute('data-citation-id'),
          citationText: dom.getAttribute('data-citation-text'),
        };
      },
    },
  ],
  toDOM(mark) {
    const { citationId, citationText } = mark?.attrs || {};
    return [
      'span',
      {
        'data-citation-id': citationId || '',
        'data-citation-text': citationText || '',
        class: 'citation-mark',
      },
      0,
    ];
  },
};

export default citationMark;
